import { Routes, Route, Navigate } from "react-router-dom"

import General from "./components/general/general.jsx"
import Login from "./components/login/login.jsx"
import AuthUser from "./components/authUser/authUser.jsx"
import Report from "./components/report/report.jsx"
import Results from "./components/results/results.jsx"
import { useAuth } from "./context/auth-context.jsx"
import { useGeneralStates } from "./context/general-context.jsx"

function Main() {
    const { user, activeVerificationCode } = useAuth()
    const { state } = useGeneralStates()
    
    return (
        <>
            <section className={`cortains-container ${state.showColumn}`}>
                <div className={`cortain ${state.showColumn}`}></div>
                <div className={`cortain ${state.showColumn}`}></div>
                <div className={`cortain ${state.showColumn}`}></div>
                <div className={`cortain ${state.showColumn}`}></div>
            </section>
            <Routes>
                <Route path="/" element={<General />} >
                    <Route path="login" element={<Login />} />
                    {activeVerificationCode && <Route path="login/authUser" element={<AuthUser />} />}
                    {user && <Route path="report" element={<Report />} />}
                </Route>

                <Route path="/results" element={<Results />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </>
    )
}

export default Main;